import { testimonials } from '@/mocks/products';

function StarRow({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((s) => (
        <i key={s} className={`text-xs ${s <= rating ? 'ri-star-fill text-[#C4FF61]' : 'ri-star-line text-gray-300'}`}></i>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const col1 = testimonials.slice(0, 2);
  const col2 = testimonials.slice(2, 4);
  const col3 = testimonials.slice(4, 6);

  return (
    <section className="bg-[#F7F8F9] py-20 md:py-28">
      <div className="px-6 md:px-12">
        {/* Header */}
        <div className="mb-12">
          <span className="inline-block bg-[#C4FF61] text-[#1A1A1A] font-outfit font-semibold text-xs px-4 py-1.5 rounded-full uppercase tracking-widest mb-4">
            Customer Reviews
          </span>
          <h2 className="font-outfit font-black text-[#1A1A1A] text-4xl md:text-5xl leading-none">
            TRUSTED BY<br />
            <em className="not-italic text-[#1A1A1A]/40">ADVENTURERS</em>
          </h2>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[col1, col2, col3].map((col, ci) => (
            <div key={ci} className="flex flex-col gap-5">
              {col.map((review) => (
                <div key={review.id} className="bg-white rounded-2xl p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-11 h-11 rounded-full object-cover object-top flex-shrink-0"
                    />
                    <div>
                      <p className="font-outfit font-semibold text-[#1A1A1A] text-sm">{review.name}</p>
                      <p className="font-inter text-gray-400 text-xs">{review.handle}</p>
                    </div>
                    <div className="ml-auto w-5 h-5 flex items-center justify-center">
                      <i className="ri-verified-badge-line text-[#C4FF61] text-base"></i>
                    </div>
                  </div>
                  <p className="font-inter text-gray-600 text-sm leading-relaxed mb-4">
                    &ldquo;{review.text}&rdquo;
                  </p>
                  <StarRow rating={review.rating} />
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Trust indicators */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-8 pt-8 border-t border-gray-200">
          {[
            { icon: 'ri-truck-line', text: 'Free Shipping $75+' },
            { icon: 'ri-refresh-line', text: '60-Day Returns' },
            { icon: 'ri-shield-check-line', text: '2-Year Warranty' },
            { icon: 'ri-headphone-line', text: '24/7 Support' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${item.icon} text-[#C4FF61] text-lg`}></i>
              </div>
              <span className="font-outfit font-medium text-[#1A1A1A] text-sm whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
